export default {"src":"/_next/static/media/warning_white.7b37bb11.svg","height":411,"width":411};